import {
  Button,
  CircularProgress,
  Container,
  Drawer,
  Grid,
  IconButton,
  Paper,
  Typography,
  useTheme,
} from "@material-ui/core";
import { IconCheckbox, IconX } from "@tabler/icons-react";
import { BitacoraMail } from "../../../interfaces/bitacoras/bitacora.interface";
import { useEffect, useState } from "react";
import { useReadBitacoraMutation } from "../../../services/reservas/reservasService";
import { format } from "date-fns";
import { enqueueSnackbar } from "notistack";
import { useAppSelector } from "../../../store/hooks";
import ConfirmDialog from "../../../components/common/dialogs/ConfirmDialog";

interface props {
  item: BitacoraMail | undefined;
  refetch: () => void;
  onClose: () => void;
}

const ReservaDetails = ({ item, refetch, onClose }: props) => {
  const theme = useTheme();
  const { userInfo } = useAppSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [showConfirmPrompt, setShowConfirmPromt] = useState(false);
  const [readBitacora, { isSuccess, isLoading }] = useReadBitacoraMutation();

  const handleReadBitacora = () => {
    setShowConfirmPromt(false);
    readBitacora({
      id_bitacora_mail: Number(item?.id_bitacora_mail),
      id_usuario_confirmacion: Number(userInfo?.id!),
    });
  };

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      // if (isSuccess === true) {
      //   refetch();
      // }
      onClose();
    }, 300);
  };

  useEffect(() => {
    if (isSuccess === true) {
      refetch();
      enqueueSnackbar("Bitácora Revisada", {
        variant: "success",
        autoHideDuration: 3000,
        anchorOrigin: {
          horizontal: "right",
          vertical: "bottom",
        },
      });
    }
  }, [isSuccess, refetch]);

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <>
      <Drawer anchor="right" open={show} onClose={handleClose}>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexWrap: "wrap",
            width: 500,
          }}
        >
          {item === undefined ? (
            <div style={{ margin: "auto auto" }}>
              <CircularProgress />
            </div>
          ) : (
            <Container>
              <Grid
                container
                spacing={0}
                style={{
                  height: "100%",
                }}
              >
                <Grid
                  item
                  xs={12}
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={onClose}
                    style={{
                      backgroundColor: "whitesmoke",
                      marginBottom: 10,
                      marginTop: 10,
                    }}
                  >
                    <IconX />
                  </IconButton>
                </Grid>
                <Grid item xs={12} style={{ height: "86%" }}>
                  <div>
                    <label>Asunto:</label>
                    <Typography variant="subtitle2">{item.asunto}</Typography>
                    <br />
                    <label>Fecha Correo: </label>
                    <Typography variant="body2">
                      {item.fecha_envio !== undefined
                        ? format(new Date(item.fecha_envio), "dd/MM/yy - HH:mm")
                        : "-"}
                    </Typography>
                    <br />
                    <label>Fecha Ingreso: </label>
                    <Typography variant="body2">
                      {item.fecha_ingresa !== undefined
                        ? format(
                            new Date(item.fecha_ingresa),
                            "dd/MM/yy - HH:mm"
                          )
                        : "-"}
                    </Typography>
                    <br />
                    <label>To: </label>
                    <Typography variant="body2">{item.to}</Typography>
                    <br />
                    <label>Cc: </label>

                    <Typography variant="body2">{item.cc}</Typography>
                    <label>Cco: </label>

                    <Typography variant="body2">{item.cco}</Typography>
                    <br />
                    <label>Información:</label>
                    <Paper
                      variant="outlined"
                      style={{
                        padding: "10px",
                        borderColor: theme.palette.primary.light,
                        backgroundColor: theme.palette.background.default,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: item.mail_info }}
                      ></div>
                    </Paper>
                    <br />
                  </div>
                </Grid>
                {item.pendiente_revisar === true ? (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    style={{
                      position: "sticky",
                      bottom: 0,
                      backgroundColor: "white",
                    }}
                  >
                    <Button
                      style={{ marginBottom: 10, marginTop: 10 }}
                      fullWidth
                      variant="contained"
                      color="primary"
                      startIcon={<IconCheckbox />}
                      onClick={() => setShowConfirmPromt(true)}
                      disabled={isLoading || isSuccess}
                    >
                      Confirmar Revisión
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            </Container>
          )}
        </div>
      </Drawer>
      <ConfirmDialog
        isOpen={showConfirmPrompt}
        text="¿Está séguro de confirmar la revisión de la reserva?"
        textConfirm="Sí, Continuar"
        onConfirm={handleReadBitacora}
        onCancel={() => setShowConfirmPromt(false)}
      />
    </>
  );
};

export default ReservaDetails;
